export default __webpack_public_path__ + "static/media/logo-noventi-white.68ba773a.png";